
<div class="row">
    <div class="col-12">
        <h5><small>{{title}}</small></h5>
    </div>
    <div class="col-4">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormGuiaTransporte">
            <mat-label>Cantidad*</mat-label>
            <input matInput formControlName="cantidad" type="number">
        </mat-form-field>
    </div>

    <div class="col-4">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormGuiaTransporte">
            <mat-label>ID Origen*</mat-label>
            <input matInput formControlName="idorigen">
        </mat-form-field>
        <mat-error *ngIf="FormGuiaTransporte.controls['idorigen'].invalid
        && FormGuiaTransporte.controls['idorigen'].touched
        && (FormGuiaTransporte.controls['idorigen'].errors.pattern || FormGuiaTransporte.controls['idorigen'].hasError('minlength') || FormGuiaTransporte.controls['idorigen'].hasError('maxlength'))">
            Campo Requrido Ej. OR123456
        </mat-error>
    </div>

    <div class="col-4">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormGuiaTransporte">
            <mat-label>ID Destino*</mat-label>
            <input matInput formControlName="iddestino">
        </mat-form-field>
        <mat-error *ngIf="FormGuiaTransporte.controls['iddestino'].invalid
        && FormGuiaTransporte.controls['iddestino'].touched
        && (FormGuiaTransporte.controls['iddestino'].errors.pattern || FormGuiaTransporte.controls['iddestino'].hasError('minlength') || FormGuiaTransporte.controls['iddestino'].hasError('maxlength'))">
            Campo Requrido Ej. DE123456
        </mat-error>    
    </div>
</div>
